import db from "@/db"; // Import your IndexedDB instance

export async function trackInteraction(type, itemId) {
  // Fetch ViewTracking setting from IndexedDB header table
  const header = await db.header.orderBy("id").last();

  if (!header || header.ViewTracking !== 1) {
    console.log("View tracking is disabled, skipping tracking.");
    return; // Exit function if tracking is disabled
  }

  const sessionId =
    window?.app?.$sessionId || localStorage.getItem("sessionId");

  try {
    await db.views.add({
      sessionId,
      type, // "walk", "poi", or "service"
      itemId,
      timestamp: Date.now(),
      synced: false,
    });
    //console.log(`Tracked: ${type} - ${itemId}`);

    // Request background sync
    requestSync();
  } catch (error) {
    //console.error("Error tracking interaction:", error);
  }
}

export async function requestSync() {
  if ("serviceWorker" in navigator && "SyncManager" in window) {
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.sync.register("sync-views");
      console.log("Background sync for views registered.");
    } catch (error) {
      console.error("Error registering sync:", error);
    }
  } else {
    console.warn("Background sync not supported, manually triggering sync...");
    syncViews(); // Fallback: Manually trigger sync
  }
}
